export default class RequiredCheckboxes {
	constructor(container) {
		const checkboxes = container.querySelectorAll('input');
		let anyChecked =
			container.querySelectorAll('input:checked').length > 0;

		checkboxes.forEach(checkbox => {
			checkbox.addEventListener('change', function() {
				anyChecked = container.querySelectorAll('input:checked').length > 0;
				checkboxes.forEach(input => {
					input.required = !anyChecked;
				});
			});

			checkbox.dispatchEvent(new Event('change'));
		});
	}
}
